// App.js
import React, { useState, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Link,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import BottomTab from "./pages/BottomTab";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import ShowGraph from "./pages/ShowGraph";
import Tab1 from "./pages/Tab1";
//import ComplaintsList from './pages/ComplaintsList';
import Logout from "./pages/LogOut";
import "./styles/bottomtab.css";
import Medicine from "./pages/Medicine";
import RecordAudio from "./components/RecordAudio";
//import { lazyLoad } from './lazyLoad';
import RegistrationPage from "./pages/RegistrationPage";
import Dashboard from "./pages/Dashboard";
import PaymentSettings from "./pages/PaymentSettings";
import SubscriptionPlan from "./pages/SubscriptionPlan";
import FrontPage from "./pages/FrontPage";
import CreatedVideoList from "./pages/CreatedVideoList";
import Support from "./pages/Support";
import SentenceExam from "./pages/SentenceExam";
import SentenceLearn from "./pages/SentenceLearn";
import VocabExam from "./pages/VocabExam";
import VocabLearn from "./pages/VocabLearn";
import VocabLearn2 from "./pages/VocabLearn2";
import VocabLearn3 from "./pages/VocabLearn3";
import SocialLogin from "./pages/SocialLogin";
import MathPage from "./pages/MathPage";
import SubjectChoicePage from "./pages/SubjectChoicePage";
import { use } from "react";
import { AuthProvider } from "./functions/AuthContext";
import UpskillReportCard from "./pages/UpskillReportCard";
import SocialLoginFBHosted from "./pages/SocialLoginFBHosted";
import AuthCallback from "./functions/AuthCallback";
import MobileNav from "./components/MobileNav"; // Import the navbar
import SentenceLearn2 from "./pages/SentenceLearn2";
import MathPage2 from "./pages/MathPage2";
import UpskillReportCard2 from "./pages/UpskillReportCard2";
import SubscriptionPlan2 from "./pages/SubscriptionPlan2";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailure from "./pages/PaymentFailure";
import Owner from "./pages/Owner";
import OwnerLanding from "./pages/OwnerLanding";
import UpskillReportCardForOwner from "./pages/UpskillReportCardForOwner";
import Computer from "./pages/Computer";
import PaymentResult from "./utils/PaymentResult";

const queryClient = new QueryClient();

// Layout component to conditionally show navbar
const LayoutWithNavbar = ({ children }) => {
  const location = useLocation();

  // Pages where we don't want to show the navbar
  const noNavbarPaths = [
    // "/",
    "/login",
    "/registration",
    "/social-login",
    "/auth-callback",
  ];

  const shouldShowNavbar = !noNavbarPaths.includes(location.pathname);

  return (
    <div className="min-h-screen bg-gray-50">
      {shouldShowNavbar && <MobileNav />}
      <main>{children}</main>
    </div>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <LayoutWithNavbar>
            <Routes>
              <Route exact path="/" element={<VocabLearn3 />} />
              {/* <Route exact path="/test" element={<VocabLearn2 />} /> */}
              <Route
                exact
                path="/social-login"
                element={<SocialLoginFBHosted />}
              />
              <Route exact path="/login" element={<LoginPage />} />
              <Route path="/auth-callback" element={<AuthCallback />} />
              <Route
                exact
                path="/registration"
                element={<RegistrationPage />}
              />
              <Route path="/landing/*" element={<VocabLearn3 />} />
              <Route path="/landing/sentence-exam" element={<SentenceExam />} />
              <Route
                path="/landing/sentence-learn"
                element={<SentenceLearn2 />}
              />
              <Route
                path="/landing/sentence-learn2"
                element={<SentenceLearn2 />}
              />
              <Route path="/landing/word-exam" element={<VocabExam />} />
              <Route path="/landing/word-learn" element={<VocabLearn3 />} />
              {/* <Route path="/landing/word-learn3" element={<VocabLearn3 />} /> */}

              <Route path="/landing/math-page" element={<MathPage />} />
              <Route
                path="/landing/subject-choice"
                element={<SubjectChoicePage />}
              />
              <Route
                path="/landing/report-card"
                element={<UpskillReportCard2 />}
              />
              <Route
                path="/landing/report-card2"
                element={<UpskillReportCard2 />}
              />
              {/*<Route path="/landing/tab2/*" element={<PrescriptionList />} />*/}
              <Route
                path="/landing/subscription"
                element={<SubscriptionPlan2 />}
              />
              <Route
                path="/landing/subscription2"
                element={<SubscriptionPlan2 />}
              />
              <Route path="/landing/VideoList" element={<CreatedVideoList />} />
              <Route path="/landing/computer" element={<Computer />} />
              <Route path="/landing/support" element={<Support />} />
              <Route path="/landing/tab3/*" element={<PaymentSettings />} />
              <Route path="/landing/tab4" element={<Logout />} />
              <Route path="/landing/tab5" element={<RecordAudio />} />
              <Route path={"/payment"} element={<Payment />} />
              <Route path={"/payment-success"} element={<PaymentSuccess />} />
              <Route path={"/payment-failure"} element={<PaymentFailure />} />
              <Route path={"/owner"} element={<Owner />} />
              <Route path={"/owner/landing"} element={<OwnerLanding />} />
              <Route path={"/owner/user-report"} element={<UpskillReportCardForOwner />} />
              <Route path={"/payment-result"} element={<PaymentResult />} />
              {/*<Route path={`/tab3/Sleep`} element={<Sleep />} />*/}
            </Routes>
          </LayoutWithNavbar>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
